export const statusSignals = [
  {
    id: "signal-1",
    icon: "ri-loader-4-line",
    title: "能否正常加载",
    good: "页面在数秒内正常打开并显示内容，说明该地址当前可用。",
    bad: "长时间白屏、反复转圈或提示无法访问，通常代表该地址已失效或不稳定，换下一条即可。",
  },
  {
    id: "signal-2",
    icon: "ri-router-line",
    title: "换线路再试",
    good: "更换网络（Wi-Fi 与移动数据互切）后能打开，说明只是当前网络的问题。",
    bad: "切换网络后依然打不开，基本可以判定是地址本身的问题，应及时回到本页取用新地址。",
  },
  {
    id: "signal-3",
    icon: "ri-shield-check-line",
    title: "页面是否正规",
    good: "主站页面结构稳定、加载流畅，没有异常弹窗，属于正常入口。",
    bad: "如果页面出现大量乱弹窗、要求输入与访问无关的敏感信息，应直接关闭，不要继续操作。",
  },
  {
    id: "signal-4",
    icon: "ri-time-line",
    title: "对照更新时间",
    good: "使用本页标注为「最近更新」的地址，可用概率最高。",
    bad: "如果你手上的地址是较早保存的，先回本页核对一下，再决定是否继续使用。",
  },
];

export const methodRows = [
  {
    id: "method-1",
    method: "主线路网页版",
    speed: "极快",
    stability: "高",
    door: "无需安装",
    freshness: "最高",
    suitable: "日常首选，电脑和手机都能用",
  },
  {
    id: "method-2",
    method: "移动优化线路",
    speed: "快",
    stability: "较高",
    door: "无需安装",
    freshness: "高",
    suitable: "手机蜂窝网络、弱网环境",
  },
  {
    id: "method-3",
    method: "APP 客户端",
    speed: "快",
    stability: "高",
    door: "需安装",
    freshness: "启动即可用",
    suitable: "长期固定使用、追求启动速度",
  },
  {
    id: "method-4",
    method: "备用线路",
    speed: "稳定",
    stability: "较高",
    door: "无需安装",
    freshness: "同步更新",
    suitable: "主线路拥堵或临时不可用时的替代",
  },
  {
    id: "method-5",
    method: "镜像入口",
    speed: "一般",
    stability: "一般",
    door: "无需安装",
    freshness: "略低",
    suitable: "其他方式都失败时的最后备选",
  },
];

export const securityTips = [
  {
    id: "tip-1",
    icon: "ri-forbid-2-line",
    title: "不轻信搜索广告位",
    desc: "通过搜索引擎查找时，排在前的广告位未必是正规入口，尽量使用本页记录并核验过的地址。",
  },
  {
    id: "tip-2",
    icon: "ri-key-2-line",
    title: "不输入无关敏感信息",
    desc: "正规访问流程通常不需要你额外提供银行卡、验证码等信息。页面一旦提出此类要求，应立即停止操作。",
  },
  {
    id: "tip-3",
    icon: "ri-window-line",
    title: "警惕仿冒页面",
    desc: "仿冒站常常排版粗糙、错别字多、弹窗频繁。遇到这类页面不要点击其中按钮，直接关闭并回到本页核对。",
  },
  {
    id: "tip-4",
    icon: "ri-download-2-line",
    title: "安装包来源要固定",
    desc: "安装包应通过可用地址页面内的官方入口获取，不要从来源不明的第三方网盘或聊天群下载文件。",
  },
  {
    id: "tip-5",
    icon: "ri-links-line",
    title: "识别可疑跳转",
    desc: "正常入口一般不会有频繁的多次跳转。若点击后连续弹出多个陌生页面，应立刻中断访问。",
  },
  {
    id: "tip-6",
    icon: "ri-refresh-line",
    title: "失效就换，别硬试",
    desc: "某条地址打不开时无需反复尝试，回到本页换一条可用线路，通常比反复刷新更省时间。",
  },
];